<template>
<div>
    <v-text-field
        prepend-icon="mdi-magnify"
        label="Search Phone Numbers"
        style="margin-top: 15px;"
        v-model="search_text"
        autocomplete="off"
    />

    <v-checkbox
        label="Show unassigned and bot phone numbers"
        v-model="include_all_endpoints"
        v-on:change="doUpdate"
        style="margin-top: -10px"
    />

    <div
        v-for="(item, index) in results"
        :key="index"
        
        :class="{ 'selected' : isSelected(item.endpoint), 'unselected' : isUnSelected(item.endpoint), 'no_home_endpoint' : noHomeEndpoint(), 'card' : true }"

        v-on:click="onClickCard(item)"
    >
        <div 
            style="float: left" 
            :class="{ 'greyed_out_text' : greyOut(item), 'regular_text': !greyOut(item) }"
        >
            <h2 style="margin-bottom: 2px;">{{item.label}}</h2>
            {{$rc.pretty(item.endpoint,'endpoint')}}
        </div>
        <div 
            style="float: right"
        >
            <div   
                v-if="item.count_unread > 0"
                class="count_unread"
            >
                {{item.count_unread}}
            </div>
        </div>

        <div style="clear: both;">
        </div>


        <div
            v-if="!item.expected_to_be_in_service"
            :class="{ 'not_following' : !item.is_following }"
            style="margin-top: 5px"
        >
            This phone number is no longer in service with RedChirp.  You can read previously sent messages but can not send or receive new messages.
        </div>
    </div>
</div>
</template>

<script>
const _ = require('lodash');

export default {

    props: {
        selected_endpoint: {
            type: String,
            default: function() { return null; }
        },

        'organization_id': {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            search_text: null,
            all_results: [],
            include_all_endpoints: false,
        }
    },

    mounted () {
        if ( this.$route.name == 'welcome_ordinary_user' )
            this.include_all_endpoints = true; 

        this.doUpdate();
    },


    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/switch-endpoint-data',
            
                'params' : {
                        'organization_id': this.organization_id,
                        'include_all_endpoints': this.include_all_endpoints,
                    },
            
                'on_success': (data) => {
                        this.all_results = data.results;
                    },
            
                'on_error': 'Unable to get phone numbers',
            });
        },

        isSelected(endpoint)
        {
            return endpoint == this.selected_endpoint;
        },

        isUnSelected(endpoint)
        {
            return this.selected_endpoint != null && endpoint != this.selected_endpoint;
        },

        noHomeEndpoint()
        {
            return this.selected_endpoint == null;
        },

        onClickCard(item)
        {
            this.$emit('select',item);
        },

        greyOut(item)
        {
            if ( this.selected_endpoint == null ) return false;
            return !item.is_following;
        },
    },

    computed: {
        results() {
            let all_results = this.all_results;

            if ( all_results == null )
                return [];
            
            let st = this.search_text;
            if ( st == null ) st = '';
            st = st.trim().toLowerCase();

            let ret = [];

            for ( let i = 0; i < all_results.length; i++ )
            {
                let cur = all_results[i];

                if ( st.length == 0 || cur.label.toLowerCase().includes(st) || cur.endpoint.includes(st) )
                {
                    ret.push(cur);
                    continue;
                }
            }

            ret.sort(
                (a, b) => {

                    if ( a.is_following == b.is_following )
                        return (a.label > b.label) ? 1 : -1;

                    return (a.is_following > b.is_following) ? -1 : 1;
                }
            );

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
.count_unread
{
    border-radius: 10px;
    background-color: #f24653;
    font-size: 12px;
    color: #FFFFFF;
    display: inline-block;
    font-size: 12px;
    height: 20px;
    letter-spacing: 0;
    line-height: 1;
    min-width: 20px;
    padding: 4px 6px;
    white-space: nowrap;
    text-align: center;
    margin-top: 15px;
    margin-right: 5px;
}

.card
{
    border-radius: 8px; margin-bottom: 7px; padding: 15px;
    cursor: pointer;
}

.unselected
{
    border: 1px solid rgba(0,0,0,0.2); 
}

.selected
{
    border: 2px solid #5D647C;
}

.no_home_endpoint
{
    border: 1px solid rgba(0,0,0,0.2); 
}

.greyed_out_text
{
    color: rgba(0,0,0,0.2)
}

.regular_text
{
    color: rgba(0,0,0,0.6)
}

</style>